import { keepPreviousData, useQueries } from '@tanstack/react-query';
import { compact } from 'lodash-es';

import type { DomainListShopPropertiesResponse, DomainProperty } from '@/Swagger';
import axiosInstance from '@/axios/axios';

async function getProperties(groupCode: string) {
  return axiosInstance
    .get<DomainListShopPropertiesResponse>('/shops/metadata/properties', {
      params: {
        groupCode: 'AIMS_CATEGORY',
        subGroupCodes: [groupCode],
      },
    })
    .then(v => ({
      parentCode: groupCode,
      children: v.data.properties,
    }));
}

/**
 * 입력으로 받은 subProperties를 파라미터로 api를 호출합니다.
 * PropertyProvider에서 사용
 */
export default function useGetSubProperties(properties: DomainProperty[]) {
  const queryResult = useQueries({
    queries: properties.map(property => ({
      queryKey: ['AIMS_CATEGORY', property.code],
      queryFn: () => getProperties(property.code),
      // keepPreviousData: true,
      placeholderData: keepPreviousData<{
        parentCode: string;
        children: DomainProperty[];
      }>,
    })),
    combine: result => {
      if (result.filter(result => result.isSuccess).length > 0) {
        return {
          data: compact(
            result.map(result => ({
              ...result.data,
              parentCode: result.data?.parentCode ?? '',
              children: result.data?.children ?? [],
            })),
          ),
        };
      }
    },
    // combine: (result) => {
    //   return {
    //     data: result.map(({ data }) => return {...data, parentCode: data?.parentCode ?? '', children: data?.children ?? []}),
    //     // isSuccess: result.every(({ isSuccess }) => isSuccess),
    //   }
    // }
  });

  // if (queryResult.filter(result => result.isSuccess).length > 0) {
  //   const newData = {
  //     data: compact(
  //       queryResult.map(result => ({
  //         ...result.data,
  //         parentCode: result.data?.parentCode ?? '',
  //         children: result.data?.children ?? [],
  //       })),
  //     ),
  //   };

  //   return newData;
  // }
  return queryResult;
}
